export const processSolanaReceipt = (transactionHash: string, sellChain: string) => {
    return [
        {
            transactionHash,
            sellChain: sellChain.toLowerCase(),
        },
    ]
}
